// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2-RLB","head":"ProcedureTableInfo_head__NOg1S"};